import React from "react";
import { Box, Typography } from "@mui/material";
import IOSSwitch from "@components/common/Switch";
import DashboardDateFilterBanner from "../DashboardDateFilterBanner";

interface DrawerFilterTogglesProps {
  hasDashboardDateFilters: boolean;
  usePreviewDateFilter: boolean;
  onPreviewDateFilterToggle?: (enabled: boolean) => void;
  activeFiltersCount: number;
  localApplyFilters: boolean;
  onFilterToggle: () => void;
  disabled?: boolean;
}

const DrawerFilterToggles: React.FC<DrawerFilterTogglesProps> = ({
  hasDashboardDateFilters,
  usePreviewDateFilter,
  onPreviewDateFilterToggle,
  activeFiltersCount,
  localApplyFilters,
  onFilterToggle,
  disabled = false,
}) => {
  const showDateFilter = hasDashboardDateFilters && !!onPreviewDateFilterToggle;
  const showApplyFilters = activeFiltersCount > 0;
  const showBanner = hasDashboardDateFilters && usePreviewDateFilter;

  if (!showBanner && !showDateFilter && !showApplyFilters) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        {showBanner && <DashboardDateFilterBanner />}
        {showDateFilter && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Use Dashboard Date Filter
            </Typography>
            <IOSSwitch
              checked={usePreviewDateFilter}
              onChange={(e) => onPreviewDateFilterToggle!(e.target.checked)}
              size="small"
              disabled={disabled}
            />
          </Box>
        )}
      </Box>

      {showApplyFilters && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Apply Filters
          </Typography>
          <IOSSwitch
            checked={localApplyFilters}
            onChange={onFilterToggle}
            size="small"
            disabled={disabled}
          />
        </Box>
      )}
    </Box>
  );
};

export default DrawerFilterToggles;
